import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

export function BookingsTableEmptyState() {
    return (
        <EmptyStateSmall
            title='No bookings'
            subtitle='When a meeting is scheduled, you’ll see it here'
            icon={
                <div style={{width: 80, height: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
